(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
const footerMedia = window.matchMedia('(min-width: 750px)');
function setFooterGroups() {
  document.querySelectorAll('.sv-art-footer__group').forEach(group => {
    group.open = footerMedia.matches;
    const summary = group.querySelector('summary');
    if (footerMedia.matches) summary.setAttribute('aria-disabled', 'true');
    else summary.removeAttribute('aria-disabled');
  });
}
document.addEventListener('click', event => {
  if (footerMedia.matches && event.target.closest('.sv-art-footer__group summary')) event.preventDefault();
});
setFooterGroups();
footerMedia.addEventListener('change', setFooterGroups);
document.addEventListener('shopify:section:load', setFooterGroups);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sv-gift-faq"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('shopify:block:select', function (event) {
  var item = event.target.closest('details[data-sv-guide-faq]');
  if (item) item.open = true;
});

  } catch(e) { console.error(e); }
})();
})();
